import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import PropTypes from "prop-types";
import i18n from 'i18n-js';
import { ThemeProvider } from '@material-ui/styles';
import themeViewnia from "components/utils/Theme";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Skeleton from '@material-ui/lab/Skeleton';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Mousewheel } from 'swiper';
import Rating from '@material-ui/lab/Rating';
import { Swiper, SwiperSlide } from 'swiper/react';
import { fetchWithLocale } from "components/utils/Api.jsx";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Mousewheel]);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
    '& .skeletons-loader': {
      borderRadius: '15px',
    },
  },
}));

function CarouselHomeBlog(props) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [slidesSkeletons, setSlidesSkeletons] = useState(1);
  const classes = useStyles();
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);

  useEffect(() => {
    const updateSkeletonCount = () => {
      const width = window.innerWidth;
      if (width >= 1280) setSlidesSkeletons(5);
      else if (width >= 1024) setSlidesSkeletons(4);
      else if (width >= 768) setSlidesSkeletons(2);
      else if (width >= 425) setSlidesSkeletons(1);
      else setSlidesSkeletons(1);
    };
    updateSkeletonCount();
    window.addEventListener("resize", updateSkeletonCount);
    return () => window.removeEventListener("resize", updateSkeletonCount);
  }, []);

  useEffect(() => {
    get_posts();
  }, []);

  function get_posts() {
    setLoading(true);
    return fetchWithLocale(`/posts.json${props.limit ? '?limit=' + props.limit : ''}`)
      .then(response => response.json())
      .then(json => {
        setPosts(json.data.posts);
        setLoading(false);
      })
      .catch(error => console.log(error));
  }

  const handleImageError = (e) => {
    e.target.onerror = null;
  };

  return (
    <ThemeProvider theme={themeViewnia}>
      {!props.home_collection_id && (
        <section className="posts">
          <header className="collections" key={"home_collection_id" + props.home_collection_title}>
            <h2><strong>{props.home_collection_title}</strong> {props.home_collection_subtitle}</h2>
            <div className="more_index">
              <a
                className="more"
                href="/blog"
                target="_blank"
                rel="noopener noreferrer"
              >
                {props.home_collection_link_text}
              </a>
            </div>
          </header>
          <section className="caroussel">
            <section className="products-section">
              {loading ? (
                <section id="skeletons-loader" className={classes.root}>
                  {Array.from({ length: slidesSkeletons }).map((_, idx) => (
                    <Skeleton
                      key={`post-skeleton-${idx}`}
                      variant="rect"
                      className="skeletons-loader"
                      width={424}
                      height={390}
                      animation="wave"
                    />
                  ))}
                </section>
              ) : (
                <>
                  <div className="swiper-button-prev" ref={navigationPrevRef}></div>
                  <div className="swiper-button-next" ref={navigationNextRef}></div>
                  <Swiper
                    navigation
                    mousewheel={false}
                    navigation={{
                      prevEl: navigationPrevRef.current,
                      nextEl: navigationNextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                      swiper.params.navigation.prevEl = navigationPrevRef.current;
                      swiper.params.navigation.nextEl = navigationNextRef.current;
                    }}
                    breakpoints={{
                      "375": { slidesPerView: 1.2, spaceBetween: 16 },
                      "425": { slidesPerView: 1.2, spaceBetween: 16 },
                      "768": { slidesPerView: 2.2, spaceBetween: 16 },
                      "1024": { slidesPerView: 4, spaceBetween: 16 },
                      "1280": { slidesPerView: 5, spaceBetween: 16 },
                    }}
                  >
                    {posts && posts.map((post) => (
                      <SwiperSlide key={`posts-label-${post.id}`}>
                        <article className="post-grid">
                          <div className="post-wraper">
                            <a
                              href={`/posts/${post.slug}`}
                              title="View Details"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {post.cover_f && (
                                <figure id="homepost">
                                  <img
                                    className="lazyload"
                                    id="homepost"
                                    src={post.cover_f}
                                    onError={handleImageError}
                                    alt={post.title}
                                  />
                                </figure>
                              )}
                              <div className="info-slide text-slide-fix">
                                <p className="zone">{post.label}</p>
                                <h3>{post.title}</h3>
                              </div>
                            </a>
                          </div>
                        </article>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </>
              )}
            </section>
          </section>
        </section>
      )}
    </ThemeProvider>
  );
}

export default CarouselHomeBlog;